// removed by extract-text-webpack-plugin
module.exports = {"botContainer":"chatbot__botContainer___ysuur","open":"chatbot__open___2Snil","botOpen":"chatbot__botOpen___s39sO","botframe":"chatbot__botframe___-9lYa","actionsWrapper":"chatbot__actionsWrapper___12OCX","menuWrapper":"chatbot__menuWrapper___2F8Uj","menu":"chatbot__menu___3_DLg"};


//////////////////
// WEBPACK FOOTER
// ./components/chatbot/chatbot.scss
// module id = ./components/chatbot/chatbot.scss
// module chunks = 5